import {
  CREATE_CONTACTBLOCK_NEW_RECORD,
  CREATE_CONTACTBLOCK_NEW_RECORD_SUCCESS,
  CREATE_CONTACTBLOCK_NEW_RECORD_ERROR,  
  
  GET_CONTACTBLOCK_NEW_RECORD,
  GET_CONTACTBLOCK_NEW_RECORD_SUCCESS,
  GET_CONTACTBLOCK_NEW_RECORD_ERROR, 
  
  GET_CONTACTBLOCK_BYID_NEW_RECORD,
  GET_CONTACTBLOCK_BYID_NEW_RECORD_SUCCESS,
  GET_CONTACTBLOCK_BYID_NEW_RECORD_ERROR,

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";

export const getContactBlockItembyIdNewRecord = (contactBlockId, history) => ({
    type: GET_CONTACTBLOCK_BYID_NEW_RECORD,
    payload: {contactBlockId, history}
  });

export const getContactBlockItembyIdNewRecordSuccess = (recordCreated) => ({
  type: GET_CONTACTBLOCK_BYID_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getContactBlockItembyIdNewRecordError = (message) => ({
  type: GET_CONTACTBLOCK_BYID_NEW_RECORD_ERROR,
  payload: { message },
});

export const getContactBlockItemNewRecord = (contactId, history) => ({
    type: GET_CONTACTBLOCK_NEW_RECORD,
    payload: {contactId, history}
  });

export const getContactBlockItemNewRecordSuccess = (recordCreated) => ({
  type: GET_CONTACTBLOCK_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getContactBlockItemNewRecordError = (message) => ({
  type: GET_CONTACTBLOCK_NEW_RECORD_ERROR,
  payload: { message },
});

export const createContactBlockItemNewRecord = (newRecord, history) => ({
    type: CREATE_CONTACTBLOCK_NEW_RECORD,
    payload: {newRecord, history}
  });

export const createContactBlockItemNewRecordSuccess = (recordCreated) => ({
  type: CREATE_CONTACTBLOCK_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createContactBlockItemNewRecordError = (message) => ({
  type: CREATE_CONTACTBLOCK_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});